import * as yup from 'yup';
import { paymentMethodScheme } from './completePayment';
export const updateCustomerUserSchema = yup.object({
    id: yup.string().required(),
    status: yup.mixed().oneOf(['ACTIVE', 'INACTIVE']).required(),
});
export const disableStoredPaymentMethodSchema = yup.object({
    recurringDetailReference: yup.string().required(),
});
export const completeStorePaymentMethodSessionSchema = yup.object({
    sessionId: yup.string().required(),
    paymentMethod: paymentMethodScheme.required(),
    recaptchaToken: yup.string().required(),
});
export const updateStoredPaymentMethodSchema = yup.object({
    paymentMethodNickname: yup.string().optional(),
});
//# sourceMappingURL=customerUser.js.map